import React from 'react'
import '../pick-loader/pick-loader.css'

export const PickLoader = () => {
    return (
        <div className="loader-size">
            <svg 
                id="e5ajmu7shu9a1" 
                xmlns="http://www.w3.org/2000/svg" 
                viewBox="-0.500000 -0.500000 242 182" 
                shapeRendering="geometricPrecision" 
                textRendering="geometricPrecision">

                <g id="e5ajmu7shu9a2">
                <g id="e5ajmu7shu9a3_to" transform="translate(120,60)">
                    <rect id="e5ajmu7shu9a3" className="primary-fill" width="40" height="120" rx="20" ry="20" transform="translate(-20,-60)" stroke="none" strokeWidth="1"/>
                </g>
                <g id="e5ajmu7shu9a4_to" transform="translate(70,55)">
                    <rect id="e5ajmu7shu9a4" className="primary-fill" width="40" height="110" rx="20" ry="20" transform="translate(-20,-55)" stroke="none" strokeWidth="1"/>
                </g>
                <g id="e5ajmu7shu9a5_to" transform="translate(20,50)">
                    <rect id="e5ajmu7shu9a5" className="primary-fill" width="40" height="100" rx="20" ry="20" transform="translate(-20,-50)" stroke="none" strokeWidth="1"/>
                </g>
                <rect id="e5ajmu7shu9a6" className="secondary-fill" width="40" height="180" rx="20" ry="20" transform="matrix(1 0 0 1 150 0)" stroke="none" strokeWidth="1"/>
                <g id="e5ajmu7shu9a7_to" transform="translate(217.347504,55)">
                    <path id="e5ajmu7shu9a7" className="secondary-fill" d="M200,55L200,30Q200,15,210.610000,25.610000L229.390000,44.390000Q240,55,229.390000,65.610000L210.610000,84.390000Q200,95,200,80Z" transform="translate(-217.347504,-55)" stroke="none" strokeWidth="1"/>
                </g>
                </g>
            </svg>
        </div>
    )
}

